/**
 * AdminSettlementDotManagement.jsx — 관리자 정산서 관리 (DOT)
 *
 * useAdminSettlement({ apiBase: 'dot' })을 사용 — DOT 전용 API 경로 (/dot/)
 * UI 구조는 AdminSettlementManagement와 완전히 동일
 */

import React from 'react';
import { useAdminSettlement } from './adminsettlement/useAdminSettlement';
import { PcView }             from './adminsettlement/PcView';
import { MobileView }         from './adminsettlement/MobileView';

export default function AdminSettlementDotManagement() {
  // apiBase = '' → 공통 API 경로 (/api/admin/settlement/...) 사용, companyCode = 'DOT'으로 분기
  const state = useAdminSettlement({ companyCode: 'DOT' });

  if (state.isMobile) {
    return <MobileView {...state} />;
  }
  return <PcView {...state} />;
}
